import React, { FC, useEffect, useMemo, memo } from 'react'
import { IonSlides, IonSlide } from '@ionic/react'
import { ProductImage } from '@cps'
import './index.scss'

interface IProps {
  no?: string;
  imgUrl: string;
  // picHeight: number;
  // picWidth: number;
  onClick?: () => void;
  pics: string;
  imgStyle: {
    width: number;
    height: number;
  };
}

const DetailTop: FC<IProps> = ({ no = '', imgStyle, imgUrl, onClick, pics }) => {
  // // 轮播参数
  // const slideOpts = {
  //   initialSlide: 0,
  //   speed: 300,
  //   autoplay: { disableOnInteraction: false },
  //   loop: true,
  //   loopPreventsSlide: true
  // }
  const imgArr = pics ? JSON.parse(pics) : []

  // const slideOpts = {
  //   initialSlide: 0,
  //   speed: 300,
  //   autoplay: { disableOnInteraction: false },
  //   loop: true,
  //   loopPreventsSlide: true
  // }

  const slideOpts = useMemo(() => {
    return {
      initialSlide: 0,
      speed: 300,
      autoplay: imgArr[0]?.type === 'video' ? false : { disableOnInteraction: false },
      // loop: true,
      // loopPreventsSlide: true
    }
  }, [])

  useEffect(() => {
    const imgArr = pics ? JSON.parse(pics) : []
    if (imgArr.length && imgArr[0].type === 'video') {
      let videoDOM = document.getElementById('video_only')
      if (imgArr.length > 1) {
        videoDOM = document.getElementById('video_0')
      }
      if (videoDOM) {
        (videoDOM as any).play()
      }
    }
  }, [pics])
  // new Array(5).fill({ type: 'img', pic: imgUrl })
  const handleVideoStartCallBack = () => {
    const swiperDOM = (document.getElementById(`advertElement${imgUrl}`) as any)
    if (swiperDOM && swiperDOM.swiper) {
      swiperDOM.swiper.autoplay.stop()
    }
  }

  const handleVideoEndCallBack = () => {
    const swiperDOM = (document.getElementById(`advertElement${imgUrl}`) as any)
    if (swiperDOM && swiperDOM.swiper) {
      swiperDOM.swiper.autoplay.start()
    }
  }
  return (
    <div className='detail-top' data-cypid={`detailTop-${no}`} onClick={onClick}>
      <div className='detail-image'>
        {
          imgArr.length === 1 || (!imgArr.length && imgUrl) ? (
            <div style={{ ...imgStyle }}>
              {
                ['image', 'product'].includes(imgArr[0]?.type) || (!imgArr.length && imgUrl) ? (
                  <ProductImage width={imgStyle.width} height={imgStyle.height} imgSrc={imgArr[0]?.url || imgUrl} />
                ) : (
                  <div className='item-resource'>
                    <div className='video-bg' style={{ backgroundImage: `url(${imgArr[0].videoImageUrl})` }}></div>
                    <video
                      src={imgArr[0]?.url}
                      id='video_only'
                      style={{ maxWidth: '100%', maxHeight: '100%' }}
                      controls
                      muted
                      playsInline
                      webkit-playsinline='true'
                      // autoPlay
                    />
                  </div>
                )
              }
            </div>
          ) : (
            <IonSlides
              id={`advertElement${imgUrl}`}
              className='slide-list'
              options={slideOpts}
              onIonSlideDidChange={() => {
                const swiperDOM = (document.getElementById(`advertElement${imgUrl}`) as any)
                imgArr.forEach((item, index) => {
                  if (item.type === 'video') {
                    const videoDOM = document.getElementById(`video_${index}`)
                    if (videoDOM) {
                      (videoDOM as any).pause()
                    }
                  }
                })
                if (swiperDOM && swiperDOM.swiper) {
                  // swiperDOM.swiper.autoplay.start()
                  // setActiveIndex(swiperDOM.swiper.realIndex + 1)
                  if (imgArr[swiperDOM.swiper.realIndex]?.type === 'video') {
                    swiperDOM.swiper.autoplay.stop()
                    const videoDOM = document.getElementById(`video_${swiperDOM.swiper.realIndex}`)
                    if (videoDOM) {
                      (videoDOM as any).play()
                    }
                  } else {
                    swiperDOM.swiper.autoplay.start()
                  }
                }
              }}
              style={{ ...imgStyle }}
            >
              {
                imgArr.map((item, index) => (
                  <IonSlide
                    key={`${item.type}_${item.url}_${index}`}
                    className='slide-item'
                  >
                    {
                      ['image', 'product'].includes(item.type) ? (
                        <div
                          className='slide-item-resource'
                          key={`${item.type}_${item.url}`}
                          style={{
                            // ...itemStyle,
                            width: imgStyle.width,
                            height: imgStyle.height,
                            backgroundImage: `url(${item.url})`
                          }}
                        />
                      ) : (
                        <div className='slide-item-resource'>
                          <div className='video-bg' style={{ backgroundImage: `url(${item.videoImageUrl})` }}>
                            {/* <img src={item.videoImageUrl} alt='' /> */}
                          </div>
                          <video
                            id={`video_${index}`}
                            src={item.url}
                            style={{ maxWidth: '100%', maxHeight: '100%' }}
                            controls
                            muted
                            playsInline
                            webkit-playsinline='true'
                            // onPlay={handleVideoStartCallBack}
                            onEnded={handleVideoEndCallBack}
                          />
                        </div>
                      )
                    }
                    <div
                      className='slide-item-pagination'
                    >
                      <span>{index + 1}</span>/{imgArr.length}
                    </div>
                  </IonSlide>
                ))
              }
            </IonSlides>
          )
        }
      </div>
    </div>
  )
}

export default memo(DetailTop)
